module.exports = __webpack_public_path__ + "img/lego-4.047890ca.jpg";